// imports section Start
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { KITCHEN_API_01, COMMON_API_01 } from "../../api/ApiModel";
import { IMAGEBASEURL } from "../../config/Config";
import { externalgetApi } from "../../services/external/externalApis";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  Alert,
  Divider,
  Pagination,
} from "@mui/material";
import Header from "../../components/common/Header";
import KitchenItemCard from "../../components/kitchen/KitchenItemCard";
import KitchenAside from "../../components/kitchen/KitchenAside";
import { useStyles } from "../../assets/styles/Theme";
import {
  CON_STATUS_ACTIVE,
  CON_CAT_TYPE_RESTAURANT,
  CON_STATUS_PENDING,
} from "../../utils/sys/Constants";

// imports section End

const Kitchen = () => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const dispatch = useDispatch();
  const [value, setValue] = useState("All");
  const [orderTypes, setOrderTypes] = useState([]);
  const [kitchenItems, setKitchenItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const itemsPerPage = 15;
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    fetchOrderTypes();
    fetchKitchenItems();
  }, []);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  // Handlers start
  const handlePageChange = (event, page) => {
    setCurrentPage(page); // Update the current page
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const filterKitchenItems = (orderType) => {
  //   if (orderType === "All") return kitchenItems;
  //   const orderTypeCode = orderTypes.find(
  //     (type) => type.ORDERTYPE === orderType
  //   )?.ORDERTYPECODE;
  //   return kitchenItems.filter((item) => item.ORDERTYPECODE === orderTypeCode);
  // };

  const filterKitchenItems = (orderType) => {
    if (orderType === "All") return kitchenItems;

    const orderTypeCode = orderTypes.find(
      (type) => type.ORDERTYPE === orderType
    )?.ORDERTYPECODE;

    return kitchenItems.filter((item) => item.ORDERTYPECODE === orderTypeCode); // Match ORDERTYPECODE
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  // Callback to handle "Order Ready" updates
  const handleOrderReady = (updatedItem) => {
    setKitchenItems((prevItems) =>
      prevItems.map((item) =>
        item.ORDERCODE === updatedItem.ORDERCODE &&
        item.KOTSEQCODE === updatedItem.KOTSEQCODE
          ? { ...item, STS: CON_STATUS_ACTIVE } // Update the order status to "ready"
          : item
      )
    );
    setRefreshTrigger((prev) => prev + 1);
  };

  // Compute paginated data
  const filteredItems = filterKitchenItems(value);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedItems = filteredItems.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // Handlers end

  // API calls start
  const fetchOrderTypes = async () => {
    try {
      const response = await externalgetApi(COMMON_API_01, "GET", {
        CATTYPE: CON_CAT_TYPE_RESTAURANT,
        STS: CON_STATUS_ACTIVE,
      });
      console.log("fetchOrderTypes kti", response);
      setOrderTypes(response);
    } catch (error) {
      setError(error);
    }
  };

  const fetchKitchenItems = async () => {
    try {
      const response = await externalgetApi(KITCHEN_API_01, "GET", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_PENDING,
      });
      setKitchenItems(response);
      console.log("responseresponse kti", response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  // API calls end

  return (
    <Box sx={styles.root}>
      <Grid container sx={styles.height}>
        {/* Kitchen screen content */}
        <Grid xs={12} sm={12} md={7} lg={8} xl={8} sx={styles.screen_content}>
          <Box
            sx={{
              backgroundColor: theme.palette.background.paper,
              width: "100%",
              padding: "12px 16px 0 16px",
              borderBottom: `2px solid ${theme.palette.stroke.main}`,
              boxShadow: 1,
            }}
          >
            <Header onSearch={handleSearch} showSearch={false} />

            {/* <Box sx={styles.tabs_container}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
              aria-label="order type tabs"
              sx={{ flexGrow: 1 }}
            >
              <Tab value="All" label="All" />
              {orderTypes.map((type) => (
                <Tab
                  key={type.ORDERTYPECODE}
                  value={type.ORDERTYPE}
                  label={type.ORDERTYPE}
                />
              ))}
            </Tabs>
          </Box> */}
          </Box>
          {/* <Divider /> */}
          <Box sx={styles.cards_container}>
            <Grid container spacing={4} sx={styles.ks_card_item}>
              {loading ? (
                <Box sx={styles.progress_circular}>
                  <CircularProgress />
                </Box>
              ) : error ? (
                <Alert severity="error">
                  Error fetching data: {error.message}
                </Alert>
              ) : (
                paginatedItems.map((kitchenItem, index) => (
                  <Grid item xs={12} sm={6} md={6} lg={4} xl={4} key={index}>
                    <KitchenItemCard
                      kitchenItem={kitchenItem}
                      IMAGEBASEURL={IMAGEBASEURL}
                      onOrderReady={handleOrderReady}
                      fetchKitchenItems={fetchKitchenItems}
                    />
                  </Grid>
                ))
              )}
            </Grid>
            {/* Pagination Controls */}
            {!loading && !error && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                <Pagination
                  count={Math.ceil(filteredItems.length / itemsPerPage)}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Box>
            )}
          </Box>
        </Grid>
        {/* Kitchen screen aside */}
        <Grid container xs={12} sm={12} md={5} lg={4} xl={4} sx={styles.height}>
          <KitchenAside refreshTrigger={refreshTrigger} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Kitchen;
